import React from 'react'
import Flex from 'components/Flex'

const Setting = () => {
  return <Flex>Setting Module</Flex>
}
export default Setting
